import { Injectable } from '@angular/core';
import { ESigningOrderType } from 'core/dto';
import { BehaviorSubject, combineLatest, map } from 'rxjs';
import { ActivityCollectionService } from '../activity-collection.service';

@Injectable()
export class ActivityItemGroupService {

  private _groupIndex!: number
  get groupIndex() {
    return this._groupIndex
  }

  set groupIndex(value: number) {
    this._groupIndex = value;
    this.groupIndexSubject.next(this._groupIndex)
  }

  readonly groupIndexSubject = new BehaviorSubject<number>(0)

  readonly groupHasMultipleItemsObs = combineLatest([
    this.groupIndexSubject,
    this._activityCollectionService.activitiesSubject,
    this._activityCollectionService.processSigningOrderSubject
  ])
    .pipe(
      map(([groupIndex, activities, processSigningOrder]) =>
        processSigningOrder === ESigningOrderType.custom
        && activities.filter(({ orderIndex }) => orderIndex === groupIndex).length > 1
      )
    )

  constructor(private _activityCollectionService: ActivityCollectionService) {

  }

  ngOnDestroy() {
    this.groupIndexSubject.complete();
  }
}
